import { Product, Variant } from "../../types/types";

export function hasSizes(product: Product): boolean {
  return Boolean(product.variants?.some(variantHasSizes));
}

function variantHasSizes(variant: Variant): boolean {
  return Boolean(variant.differentiators?.size);
}
